import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled, { css } from 'styled-components'
import { useViews } from 'state'
import { Reactions } from './Reactions'
import { FavoriteBorder, PeopleAltOutlined, PeopleAlt, LocalMallOutlined } from '@material-ui/icons'
import Badge from '@mui/material/Badge'
import { selectCurrentStore } from '../../reducers/storeSlice'
import {
  notifyLikeMeesage,
  selectIsLikeButtonVisible,
  selectRemoteLikeVisible,
  setLocalLikeAnimation,
  setRemoteLikeAnimation,
} from '../../reducers/uiSlice'
import ShareButton from './ShareButton'
import { ChatButton } from './ChatButton'
import { RoundedButton } from '../Kit/Buttons'
import { selectUsersCount } from '../../reducers/callSlice'
import { PIPButton } from '../GJKit/PIPButton'
import { useInHouseMetrics, usePostHogAnalytics } from '@gojiraf/analytics'
import { useDevices } from '@gojiraf/responsive'

export const ActionBar = () => {
  const { isDesktop } = useDevices()
  const { trackEvent: inHouseTrackEvent } = useInHouseMetrics()
  const { postHogTrackEvent } = usePostHogAnalytics()
  const dispatch = useDispatch()
  const store = useSelector(selectCurrentStore)
  const { sendLikeAnimation, chat } = store.storeConfigurations.features
  const { isOneToManySale } = store
  const remoteLikeVisible = useSelector(selectRemoteLikeVisible)
  const isLikeButtonVisible = useSelector(selectIsLikeButtonVisible)
  const usersCount = useSelector(selectUsersCount)
  const { state, send } = useViews()

  const showLike = () => {
    inHouseTrackEvent('message-like')
    postHogTrackEvent('message-like')
    dispatch(setLocalLikeAnimation({ localLikeAnimation: true }))
    if (!remoteLikeVisible) {
      dispatch(setRemoteLikeAnimation({ remoteLikeAnimation: true }))
      if (sendLikeAnimation) dispatch(notifyLikeMeesage())
    }
  }

  const showParticipants = () => {
    postHogTrackEvent('show-participants-cameras-button')
    send({ type: 'SHOW_PARTICIPANTS' })
  }

  const showProducts = () => {
    postHogTrackEvent('product-click-catalog')
    send({ type: 'SHOW_PRODUCTS' })
  }

  useEffect(() => {
    let timeoutId

    const startLoop = () => {
      const delay = Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000 // Entre 1 y 10 segundos
      timeoutId = setTimeout(() => {
        if (!remoteLikeVisible) dispatch(setRemoteLikeAnimation({ remoteLikeAnimation: true }))
        startLoop()
      }, delay)
    }

    if (!sendLikeAnimation && isLikeButtonVisible) {
      startLoop()
    }

    return () => clearTimeout(timeoutId)
  }, [])

  return (
    <ActionBarContainer isDesktop={isDesktop}>
      {!isOneToManySale && isDesktop && chat.enabled ? <ChatButton /> : null}
      {!isOneToManySale && isDesktop && (
        <RoundedButton
          color="secondary"
          onClick={showParticipants}
          id="show-participants-cameras-button"
          data-test="show-participants-cameras-button"
        >
          <StyledBadge badgeContent={usersCount} max="99">
            {state.matches('secondary.showingParticipants') === true ? (
              <PeopleAlt />
            ) : (
              <PeopleAltOutlined />
            )}
          </StyledBadge>
        </RoundedButton>
      )}

      {isDesktop ? (
        <>
          <Spacer />
          <PIPButton isMobile={false} />
          <ShareButton />
        </>
      ) : (
        <>
          <ShareButton />
          <RoundedButton
            color="secondary"
            onClick={showProducts}
            id="product-click-catalog"
            data-test="product-click-catalog"
            data-tour="catalog-button"
          >
            <LocalMallOutlined />
          </RoundedButton>
        </>
      )}

      {isLikeButtonVisible && (
        <>
          <RoundedButton
            id="like-button"
            color="secondary"
            aria-label="Favorite"
            data-tour="like-button"
            onClick={showLike}
          >
            <Reactions data-test="like-button" />
            <FavoriteBorder />
          </RoundedButton>
        </>
      )}
      {!isOneToManySale && !isDesktop && (
        <RoundedButton
          color="secondary"
          onClick={showParticipants}
          id="show-participants-cameras-button"
          data-test="show-participants-cameras-button"
        >
          <StyledBadge badgeContent={usersCount} max="99">
            {state.matches('secondary.showingParticipants') === true ? (
              <PeopleAlt />
            ) : (
              <PeopleAltOutlined />
            )}
          </StyledBadge>
        </RoundedButton>
      )}
    </ActionBarContainer>
  )
}

const ActionBarContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      background: linear-gradient(
        to bottom,
        transparent,
        rgba(0, 0, 0, 0.5) 5rem,
        rgba(0, 0, 0, 0.5) 100%
      );
      padding: 1rem;
      padding-top: 0.5rem !important;
    `}
`

const Spacer = styled.div`
  flex-grow: 1;
`

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    fontFamily: 'Montserrat',
    backgroundColor: '#000',
  },
}))
